import { SitePageShell } from "@/components/SiteHeader";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { trpc } from "@/lib/trpc";
import { formatKRW } from "@shared/pricing";
import { CheckCircle2, Loader2 } from "lucide-react";
import { useMemo } from "react";
import { Link } from "wouter";

export default function OrderCompletePage() {
  const orderId = useMemo(() => {
    const url = new URL(window.location.href);
    return Number(url.searchParams.get("orderId") ?? "0");
  }, []);
  const detail = trpc.orders.detail.useQuery(
    { id: orderId },
    { enabled: orderId > 0 },
  );

  return (
    <SitePageShell>
      <div className="container py-16 max-w-2xl">
        <div className="text-center mb-10">
          <CheckCircle2 className="w-14 h-14 text-accent mx-auto mb-4" />
          <h1 className="font-serif text-3xl text-primary">
            주문이 완료되었습니다
          </h1>
          <p className="text-muted-foreground mt-2 text-sm">
            소중한 작품 제작에 들어갑니다. 진행 상황은 마이페이지에서 확인하실
            수 있습니다.
          </p>
        </div>

        {detail.isLoading && (
          <div className="flex justify-center">
            <Loader2 className="animate-spin text-muted-foreground" />
          </div>
        )}

        {detail.data && (
          <Card className="overflow-hidden py-0">
            <div className="grid sm:grid-cols-[160px_1fr]">
              <img
                src={detail.data.order.imageUrl}
                alt="작품"
                className="w-full aspect-square sm:aspect-auto sm:h-full object-cover"
              />
              <CardContent className="p-5 space-y-4">
                <div className="flex justify-between items-baseline pb-3 border-b border-border/60">
                  <div>
                    <div className="text-xs text-muted-foreground">주문번호</div>
                    <div className="font-mono text-sm">
                      {detail.data.order.orderNo}
                    </div>
                  </div>
                  <div className="text-right">
                    <div className="text-xs text-muted-foreground">결제금액</div>
                    <div className="font-serif text-xl tabular-nums text-primary">
                      {formatKRW(detail.data.order.totalAmount)}
                    </div>
                  </div>
                </div>
                <div className="text-sm space-y-2">
                  <div className="font-medium text-primary">선택 옵션</div>
                  <ul className="text-muted-foreground space-y-0.5">
                    {detail.data.items.map((i) => (
                      <li key={i.id}>· {i.productName}</li>
                    ))}
                  </ul>
                </div>
                {detail.data.shipping && (
                  <div className="text-sm border-t border-border/60 pt-3">
                    <div className="text-muted-foreground text-xs mb-1">
                      배송지
                    </div>
                    <div>
                      {detail.data.shipping.recipientName} ·{" "}
                      {detail.data.shipping.phone}
                    </div>
                    <div className="text-muted-foreground">
                      [{detail.data.shipping.postalCode}]{" "}
                      {detail.data.shipping.address1}{" "}
                      {detail.data.shipping.address2}
                    </div>
                  </div>
                )}
              </CardContent>
            </div>
          </Card>
        )}

        <div className="mt-8 flex gap-3 justify-center">
          <Button asChild variant="outline">
            <Link href="/">홈으로</Link>
          </Button>
          <Button asChild>
            <Link href="/my">마이페이지에서 보기</Link>
          </Button>
        </div>
      </div>
    </SitePageShell>
  );
}
